// extracted by mini-css-extract-plugin
module.exports = {"forgotPassword":"index--forgotPassword--3Ex1z"};